<!-- 运维视图: 交接班事项 -->
<template>
    <div>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>交接班事项</span>
                <el-button v-if="addBtnExisted" @click="toAddHandoverMatter" style="float: right; padding: 3px 0;margin-left:10px;" type="text">
                    <span title="新增交接班事项">
                        <i class="el-icon-folder-add">
                        </i>
                        新增
                    </span>
                </el-button>
                <!--<el-button v-if="allFinishBtnExisted" @click="allFinish" style="float: right; padding: 3px 0;" type="text">
                    <span title="完成所有未完成的交接班事项">
                        <i class="el-icon-document-checked">
                        </i>
                        全部完成
                    </span>
                </el-button>-->
                <el-button v-if="deleteBtnExisted" @click="toDeleteHandoverMatter" style="float: right; padding: 3px 0;" type="text">
                    <span title="请先选择一个交接班事项，再进行删除">
                        <i class="el-icon-delete">
                        </i>
                       删除
                    </span>
                </el-button>
                <el-button v-if="editBtnExisted" @click="toEditHandoverMatter" style="float: right; padding: 3px 0;" type="text">
                    <span title="请先选择一个交接班事项，再进行编辑">
                        <i class="el-icon-edit-outline">
                        </i>
                       编辑
                    </span>
                </el-button>
            </div>
            <div>
                <ul class="scroll-m" id="matter">
                    <li v-if="handoverMatters == null || handoverMatters.length <= 0">
                        暂无事项
                    </li>
                    <li v-else :key="handoverMatter.id" v-for="(handoverMatter, index) in handoverMatters" :class="{'margin-top-10': index > 0}">
                        <el-row :class="{'warning': handoverMatter.overtime, 'normal': !handoverMatter.overtime}">
                            <el-tooltip :content="handoverMatter.description" placement="top" effect="light" :disabled="handoverMatter.description.length <= 40">
                                <el-alert :type="handoverMatter.overtime ? 'error' : 'info'" :closable="false">
                                    <el-row>
                                        <el-col :xl="19" :lg="17" :md="15" :sm="24" :xs="24">
                                            <div style="overflow-x: hidden">
                                                <el-radio v-if="handoverMatterRadioExisted && handoverMatter.initiatorId === logbook.logbookId"
                                                          style="margin-right: 5px;" class="label-hidden" v-model="handoverMatterId" :label="handoverMatter.id">
                                                </el-radio>
                                                {{handoverMatter.description.length > 40 ? handoverMatter.description.substring(0, 40) + '...' : handoverMatter.description}}
                                            </div>
                                        </el-col>
                                        <el-col :xl="5" :lg="7" :md="9" :sm="24" :xs="24">
                                            <el-row type="flex" justify="end">
                                                <i class="el-icon-tickets red-font bold handover-matter-status-icon" style="cursor: pointer;"
                                                   @click="showTracks(handoverMatter)" v-if="handoverMatter.lastLogbookTrackStatus === 1">
                                                </i>
                                                <i class="el-icon-document-checked green-font bold handover-matter-status-icon" style="cursor: pointer;"
                                                   @click="showTracks(handoverMatter)" v-if="handoverMatter.lastLogbookTrackStatus === 2">
                                                </i>
                                                <el-button v-if="finishBtnExisted" @click="showRemarkDialog(handoverMatter, 2)"
                                                           :class="{'clicked': handoverMatter.logbookTrackStatus === 2}"
                                                           size="mini">完成</el-button>
                                                <el-button v-if="doNotFinishBtnExisted" @click="showRemarkDialog(handoverMatter, 1)"
                                                           :class="{'clicked': handoverMatter.logbookTrackStatus === 1}"
                                                           size="mini">未完成</el-button>
                                            </el-row>
                                        </el-col>
                                    </el-row>
                                </el-alert>
                            </el-tooltip>
                        </el-row>
                    </li>
                </ul>
            </div>
        </el-card>

        <el-dialog title="交接班事项" :visible.sync="handoverMatterDialogVisible" width="30%">
            <el-input v-model="description" maxlength="60" show-word-limit size="mini">
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-row>
                    <el-button @click="cancelHandoverMatterDialog" size="small">取 消</el-button>
                    <el-button v-if="handoverMatterOperation === 'ADD'" type="primary" @click="saveAdd" size="small">确 定</el-button>
                    <el-button v-if="handoverMatterOperation === 'EDIT'" type="primary" @click="saveEdit" size="small">确 定</el-button>
                </el-row>
            </div>
        </el-dialog>

        <el-dialog title="事项追踪说明" :visible.sync="remarkDialogVisible" width="30%">
            <el-input v-model="remark" maxlength="60" show-word-limit size="mini">
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-row>
                    <el-button @click="cancelRemarkDialog" size="small">取 消</el-button>
                    <el-button v-if="operation === 2" type="primary" @click="finish" size="small">确 定</el-button>
                    <el-button v-if="operation === 1" type="primary" @click="doNotFinish" size="small">确 定</el-button>
                </el-row>
            </div>
        </el-dialog>

        <el-dialog title="事项追踪说明" :visible.sync="remarksDialogVisible" width="60%" @close="remarksDialogVisible = false">
            <div>
                <el-table :data="handoverMatterTracks">
                    <el-table-column label="时间">
                        <template slot-scope="scope">
                            {{scope.row.remarkTime}}
                        </template>
                    </el-table-column>
                    <el-table-column label="姓名">
                        <template slot-scope="scope">
                            {{scope.row.remarkUserRealName}}
                        </template>
                    </el-table-column>
                    <el-table-column label="备注">
                        <template slot-scope="scope">
                            {{scope.row.remark}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-row>
                    <el-button @click="remarksDialogVisible = false" size="small">关 闭</el-button>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import _ from 'lodash';
    import {parseDate} from 'element-ui/src/utils/date-util';
    import DutyServer from '@/api/duty';
    import {AuthInfo} from "@/util/user/authInfo";
    import person from "@/api/person/person";

    export default {
        name: "operation-board-handover-matter",
        props: {
            departmentId: {},
            logbook: {},
        },
        data() {
            return {
                handoverMatters: [],

                handoverMatterDialogVisible: false,
                handoverMatterOperation: null,
                description: null,
                handoverMatterId: null,

                remarkDialogVisible: false,
                handoverMatter: null,
                remark: null,
                operation: null,

                remarksDialogVisible: false,
                handoverMatterTracks: [],
            };
        },
        computed: {
            addBtnExisted() {
                let logbook = this.logbook;
                return logbook != null && logbook.status === 'DRAFT';
            },
            editBtnExisted() {
                let logbook = this.logbook;
                return logbook != null && logbook.status === 'DRAFT';
            },
            deleteBtnExisted() {
                let logbook = this.logbook;
                return logbook != null && logbook.status === 'DRAFT';
            },
            allFinishBtnExisted() {
                let logbook = this.logbook;
                return logbook != null && logbook.status === 'DRAFT';
            },
            handoverMatterRadioExisted() {
                let logbook = this.logbook;
                return logbook != null && logbook.status === 'DRAFT';
            },
            finishBtnExisted() {
                let logbook = this.logbook;
                return logbook != null && logbook.status === 'DRAFT';
            },
            doNotFinishBtnExisted() {
                let logbook = this.logbook;
                return logbook != null && logbook.status === 'DRAFT';
            },
            loadHandoverMattersTrigger() {
                return {
                    departmentId: this.departmentId,
                    logbookId: this.logbook == null ? null : this.logbook.logbookId,
                };
            },
        },
        watch: {
            loadHandoverMattersTrigger: {
                deep: true,
                handler() {
                    this.loadHandoverMatters();
                },
            },
        },
        methods: {
            async loadHandoverMatters() {
                let handoverMatters = [];
                let logbookId = this.logbook == null ? null : this.logbook.logbookId;
                if (this.departmentId != null && logbookId != null) {
                    let response = await DutyServer.handoverMatter.getHandoverMatters(this.departmentId, logbookId);
                    if (response.status === 200 && response.data.code === 200) {
                        handoverMatters = response.data.result;
                    } else {
                        this.$message.error(response.data.message);
                    }
                }
                let currentDateTime = new Date();
                for (let i = 0, len = handoverMatters.length; i < len; i++) {
                    let handoverMatter = handoverMatters[i];
                    let overtime = false;
                    if (String(handoverMatter.status) !== '2') {
                        let beginTime = parseDate(handoverMatter.beginTime, 'yyyy-MM-dd HH:mm:ss');
                        if ((currentDateTime.getTime() - beginTime.getTime()) / 3600000 > 36) {
                            overtime = true;
                        }
                    }
                    handoverMatter.overtime = overtime;
                }
                // sortHandoverMatters(handoverMatters);
                this.handoverMatters = handoverMatters;
                return Promise.resolve(handoverMatters);
            },
            clearHandoverMatter() {
                this.description = null;
                this.handoverMatterId = null;
            },
            closeHandoverMatterDialog() {
                this.handoverMatterDialogVisible = false;
                this.handoverMatterOperation = null;
                this.clearHandoverMatter();
            },
            cancelHandoverMatterDialog() {
                this.handoverMatterDialogVisible = false;
                this.handoverMatterOperation = null;
                this.clearHandoverMatter();
            },
            toAddHandoverMatter() {
                this.clearHandoverMatter();
                this.handoverMatterOperation = 'ADD';
                this.handoverMatterDialogVisible = true;
            },
            checkSelect(message) {
                let result = true;
                let handoverMatterId = this.handoverMatterId;
                if (handoverMatterId == null || handoverMatterId === '') {
                    this.$message.error(message || '请选择需要操作的交接班事项');
                    result = false;
                }
                return result;
            },
            async toEditHandoverMatter() {
                if (!this.checkSelect('请选择需要编辑的的交接班事项')) {
                    return ;
                }
                let handoverMatterId = this.handoverMatterId;
                let response = await DutyServer.handoverMatter.get(handoverMatterId);
                if (response.status === 200 && response.data.code === 200) {
                    let handoverMatter = response.data.result;
                    this.description = handoverMatter.description;
                    this.handoverMatterOperation = 'EDIT';
                    this.handoverMatterDialogVisible = true;
                } else {
                    this.$message.error(response.data.message);
                }
            },
            async toDeleteHandoverMatter() {
                if (!this.checkSelect('请选择需要删除的交接班事项')) {
                    return ;
                }
                let handoverMatterId = this.handoverMatterId;
                let response = await DutyServer.handoverMatter.delete(handoverMatterId);
                let result = null;
                if (response.status === 200 && response.data.code === 200) {
                    result = response.data.result;
                    this.clearHandoverMatter();
                    this.loadHandoverMatters();
                    this.$message.success('删除的交接班事项成功');
                } else {
                    this.$message.error(response.data.message);
                }
                return Promise.resolve(result);
            },
            async saveAdd() {
                let departmentId = this.departmentId;
                let logbookId = this.logbook == null ? null : this.logbook.logbookId;
                let description = this.description;
                let userId = AuthInfo.userId;

                let response = await DutyServer.handoverMatter.add({
                    departmentId: departmentId,
                    logbookId: logbookId,
                    description: description,
                    userId: userId,
                });
                let result = null;
                if (response.status === 200 && response.data.code === 200) {
                    result = response.data.result;
                    this.closeHandoverMatterDialog();
                    this.loadHandoverMatters();
                    this.$message.success('新增交接班事项成功');
                } else {
                    this.$message.error(response.data.message);
                }
                return Promise.resolve(result);
            },
            async saveEdit() {
                let handoverMatterId = this.handoverMatterId;
                let description = this.description;
                let userId = AuthInfo.userId;
                let response = await DutyServer.handoverMatter.updateDescription(handoverMatterId, description, userId);
                let result = null;
                if (response.status === 200 && response.data.code === 200) {
                    result = response.data.result;
                    this.closeHandoverMatterDialog();
                    this.loadHandoverMatters();
                    this.$message.success('编辑交接班事项成功');
                } else {
                    this.$message.error(response.data.message);
                }
                return Promise.resolve(result);
            },
            async showRemarkDialog(handoverMatter, operation) {
                let handoverMatterTrack = null;
                let handoverMatterId = handoverMatter.id;
                let logbookId = this.logbook == null ? null : this.logbook.logbookId;
                let response = await DutyServer.handoverMatter.getTrack(handoverMatterId, logbookId);
                if (response.status === 200 && response.data.code === 200) {
                    handoverMatterTrack = response.data.result;
                } else {
                    this.$message.error(response.data.message);
                }
                this.handoverMatter = handoverMatter;
                this.remark = handoverMatterTrack == null ? null : handoverMatterTrack.remark;
                this.remarkDialogVisible = true;
                this.operation = operation;
                return Promise.resolve();
            },

            async allFinish() {
                if (this.handoverMatters == null || this.handoverMatters.length <= 0) {
                    return ;
                }
                let handoverMatterIds = this.handoverMatters.filter(e => e.status !== 2).map(e => e.id);
                let logbookId = this.logbook == null ? null : this.logbook.logbookId;
                let userId = AuthInfo.userId;
                let response = await DutyServer.handoverMatter.batchFinish(handoverMatterIds, logbookId, userId);
                let result = null;
                if (response.status === 200 && response.data.code === 200) {
                    result = response.data.result;
                    this.loadHandoverMatters();
                    this.$message.success('操作成功');
                } else {
                    this.$message.error(response.data.message);
                }
                return Promise.resolve(result);
            },
            clearRemark() {
                this.handoverMatter = null;
                this.remark = null;
            },
            closeRemarkDialog() {
                this.remarkDialogVisible = false;
                this.clearRemark();
            },
            cancelRemarkDialog() {
                this.closeRemarkDialog();
            },
            async finish() {
                let remark = this.remark;
                if (remark == null || remark.trim() === '') {
                    this.$message.error('备注不能为空！');
                    return Promise.resolve(null);
                }
                let handoverMatter = this.handoverMatter;
                let handoverMatterId = handoverMatter.id;
                let logbookId = this.logbook == null ? null : this.logbook.logbookId;
                let userId = AuthInfo.userId;
                let response = await DutyServer.handoverMatter.finish(handoverMatterId, logbookId, remark, userId);
                let result = null;
                if (response.status === 200 && response.data.code === 200) {
                    result = response.data.result;
                    this.closeRemarkDialog();
                    this.loadHandoverMatters();
                    this.$message.success('操作成功');
                } else {
                    this.$message.error(response.data.message);
                }
                return Promise.resolve(result);
            },
            async doNotFinish() {
                let remark = this.remark;
                if (remark == null || remark.trim() === '') {
                    this.$message.error('备注不能为空！');
                    return Promise.resolve(null);
                }
                let handoverMatter = this.handoverMatter;
                let handoverMatterId = handoverMatter.id;
                let logbookId = this.logbook == null ? null : this.logbook.logbookId;
                let userId = AuthInfo.userId;
                let response = await DutyServer.handoverMatter.doNotFinish(handoverMatterId, logbookId, remark, userId);
                let result = null;
                if (response.status === 200 && response.data.code === 200) {
                    result = response.data.result;
                    this.closeRemarkDialog();
                    this.loadHandoverMatters();
                    this.$message.success('操作成功');
                } else {
                    this.$message.error(response.data.message);
                }
                return Promise.resolve(result);
            },
            async showTracks(handoverMatter) {
                let handoverMatterTracks = [];
                let handoverMatterId = handoverMatter.id;
                let logbookId = this.logbook == null ? null : this.logbook.logbookId;
                let response = await DutyServer.handoverMatter.getPreviousAndCurrentTracks(handoverMatterId, logbookId);
                if (response.status === 200 && response.data.code === 200) {
                    handoverMatterTracks = response.data.result;
                } else {
                    handoverMatterTracks = [];
                    this.$message.error(response.data.message);
                }
                let persons = await person.fetchByRedis({});
                let personsMap = _.keyBy(persons, 'id');
                handoverMatterTracks.forEach(e => {
                    let person;
                    if (e.remarkUserId != null && (person = personsMap[e.remarkUserId]) != null) {
                        e.remarkUserRealName = person.realName;
                    } else {
                        e.remarkUserRealName = e.remarkUserId;
                    }
                });
                // handoverMatterTracks = handoverMatterTracks.filter(e => String(e.status) !== '2' && e.remark != null && e.remark !== '');
                this.handoverMatterTracks = handoverMatterTracks;
                this.remarksDialogVisible = true;
            },
        },
    }
</script>

<style scoped>
    .margin-top-10{
        margin-top: 10px;
    }
    .handover-matter-status-icon {
        font-size: 22px;
        margin-top: 3px;
        margin-right: 10px;
    }
    .el-row {
        margin: 0;
    }
    .clicked {
        background-color: #b9cee5;
    }
</style>
